@use '../../../styles/Constants.scss' as Constants;
@use '../../../styles/Colors.scss' as Colors;

$var-resizer-width: Constants.$val-spacing-s;
$var-gap-size: Constants.$val-spacing-m;
$var-header-footer-height: 26px;
$var-drawer-width: 40px;
$var-panel-width: 320px;
$var-company-header-height: 64px;
$var-breadcrumbs-header-height: 56px;
$var-tabs-navigation-height: 64px;
$var-shadow: 0 1px 4px 0 Colors.$col-shadow;

@mixin row {
	display: grid;
	align-items: stretch;
	min-height: $var-header-footer-height;
}

@mixin cell ($type) {
	font-weight: normal;
	display: flex;
	align-items: center !important;
	height: 100%;
	font-size: Constants.$val-fontSizeSmall !important;
	line-height: Constants.$val-fontSizeRegular;
	align-items: stretch;
	min-width: 0;
	overflow-x: hidden;

	@if $type ==header {
		color: Colors.$col-design-grey15;
		font-size: Constants.$val-fontSizeSmall;
		cursor: pointer;
		display: flex;
		align-items:center;
		justify-content:center;
		text-align: center;
	}

	@if $type ==regular {
		color: Colors.$col-blackDark;

		border-left: 1px solid Colors.$col-design-grey14;
		border-bottom: 1px solid Colors.$col-design-grey14;
		border-top: 1px solid transparent;
		border-right: 0;

		&:first-child {
			border-left: 0;
		}

		&:focus-within:not(.readonly) {
			border: 1px solid Colors.$col-orangeBorder !important;
			z-index: 1;
		}
	}

	&:has(div > :global(.show.dropdown)) {
		z-index: 12;
	}

	&:has(:global(.form-group)) {
		& > div {
			margin-bottom: 0px; // form-group has margin-bottom for some reason
		}

		&:has(:global(.help-block)) {
			margin-top: Constants.$val-spacing-m;
			padding: 0;
		}
	}

	&:has(div > :global(.show.dropup)) {
		z-index: 12;
	}

	&:has(:global(.date-input__popper--fixed .react-datepicker)) {
		z-index: 12;
	}
}

.simple-table {
	background-color: Colors.$col-design-grey12;
	overflow-x: hidden;
	border: 1px solid Colors.$col-design-grey14;
	display: flex;
	flex-direction: column;
	min-height: 0;
	position: relative;
	box-sizing: border-box;
	
	&__body {
		display: grid;
		grid-template-columns: minmax(0, 1fr);
		background-color: Colors.$col-design-grey12;
		overflow-x: auto;
		overflow-y: auto;
		min-height: 0;
		flex: 1 1;
		align-content: start;
	}

	&__title-row {
		padding: Constants.$val-spacing-s Constants.$val-spacing-l;
		border-bottom: 1px solid Colors.$col-design-grey14;
		display: flex;
		justify-content: flex-end;
		position: sticky;
		top: 0;
		z-index: 3;
		background-color: Colors.$col-design-grey12;

		&__label {
			flex: 1;
			color: Colors.$col-design-grey10;
			text-transform: uppercase;
		}

		&__buttons {
			display: flex;
			gap: Constants.$val-spacing-s;
		}
	}

	&__empty-table-message {
		display: flex;
		color: Colors.$col-greyMid;
		font-style: italic;
		padding: Constants.$val-spacing-xs Constants.$val-spacing-l;
		border-top: none;
	}

	&__header-row {
		@include row;
		position: sticky;
		height: max-content;
		top: 0px;
		z-index: 5;
		background-color: Colors.$col-design-grey12;
	}

	&__row {
		@include row;
		height: max-content;
		background-color: Colors.$col-design-grey13;

		&:last-child {
			.simple-table__cell {
				border-bottom: 0;
			}
		}
	}

	&__cell {
		@include cell(regular);

		&--fixed {
		position: sticky;
		background-color: Colors.$col-design-grey13;
		z-index: 3;

		border-right: 1px solid Colors.$col-design-grey14;

		&:last-child {
			&::after {
				content: '';
				position: absolute;
				top: 0;
				right: -1px;
				bottom: 0;
				width: 1px;
				background-color: Colors.$col-design-grey14;
				pointer-events: none;
			}
		}
	}
	}

	&__resizer {
		color: Colors.$col-greyInactive;
		cursor: col-resize;
		min-width: $var-resizer-width;
		max-width: $var-resizer-width;
		margin-right: 0px;
		height: 100%;
	}

	&__footer-component {
		border-top: 1px solid Colors.$col-design-grey14;
	}

	&__footer {
		display: flex;
		justify-content: space-between;
		padding: Constants.$val-spacing-xs Constants.$val-spacing-l;
		background-color: Colors.$col-design-grey12;
		border-top: 1px solid Colors.$col-design-grey14;
		position: sticky;
		bottom: 0;
		background: Colors.$col-design-grey12;
	}

	&__footer-buttons {
		display: flex;
		gap: $var-gap-size;
	}

	&__button {
		color: Colors.$col-blue;
		cursor: pointer;

		&:hover {
			color: Colors.$col-darkBlueBorder;
		}

		& > [class^="icon-"] {
			color: Colors.$col-blue;
			margin-right: Constants.$val-spacing-s;

			&:hover {
				color: Colors.$col-darkBlueBorder;
			}
		}
	}

	&__sort-disabled {
		color: Colors.$col-disabled;
		cursor: default;
	}

	&__layout {
		display: flex;
		width: 100%;
		min-width: 0; // important for overflow/flex children
		flex: 1 1;
		min-height: 0;
	}

	&__drawer-rail {
		width: $var-drawer-width;
		min-width: $var-drawer-width;
		border-left: 1px solid Colors.$col-design-grey14;
		background-color: Colors.$col-design-grey12;

		display: flex;
		align-items: flex-start;
		justify-content: center;
		padding-top: Constants.$val-spacing-s;

		z-index: 60;
	}

	&__drawer-rail--open {
		padding-top: Constants.$val-spacing-s;
	}

	&__main {
		position: relative;
		flex: 1 1;
		min-width: 0;
		min-height: 0;
		display: flex;
		flex-direction: column;
	}

	&__drawer-panel {
		position: absolute;
		right: -$var-drawer-width;
		top: 0;
		height: fit-content;

		width: $var-panel-width;
		background-color: Colors.$col-design-grey12;
		border-left: 1px solid Colors.$col-design-grey14;

		z-index: 50;

		transform: translateX(100%);
		transition: transform 160ms ease;

		display: flex;
		flex-direction: column;
		pointer-events: none;
	}

	&__drawer-panel--open {
		transform: translateX(0);
		pointer-events: auto;
	}

	&__drawer-panel__header {
		display: flex;
		align-items: center;
		gap: Constants.$val-spacing-s;

		padding: Constants.$val-spacing-s;
		border-bottom: 1px solid Colors.$col-design-grey14;
		background-color: Colors.$col-design-grey12;
	}

	&__drawer-toggle {
		width: 28px;
		height: 28px;
		border: 1px solid Colors.$col-design-grey14;
		background: Colors.$col-design-grey13;
		cursor: pointer;
		border-radius: 4px;

		display: flex;
		align-items: center;
		justify-content: center;

		flex: 0 0 auto;
	}

	&__drawer-panel__content {
		overflow: visible;
	}

	&__drawer-panel__title {
		flex: 1;
		color: Colors.$col-design-grey10;
		font-weight: bold;
		text-transform: uppercase;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	&__header-grid {
		display: grid;
		position: sticky;
		top: 0;
		z-index: 5;
		background-color: Colors.$col-design-grey12;
		min-width: min-content;
	}

	&__header-grid-cell {
		position: relative;
		min-width: 0;
		background-color: Colors.$col-design-grey12;
		display: flex;
		align-items: stretch;
		box-sizing: border-box;

		border-left: 1px solid Colors.$col-design-grey14;
		border-top: 0;
		border-right: 0;
		border-bottom: 0;

		z-index: 1;

		&--first-col {
			border-left: 0;
		}

		&--needs-right-border {
			border-right: 0;

			&::after {
				content: '';
				position: absolute;
				top: 0;
				right: -1px;
				bottom: 0;
				width: 1px;
				background-color: Colors.$col-design-grey14;
				z-index: 5;
				pointer-events: none;
			}
		}

		&--needs-top-border {
			border-top: 1px solid Colors.$col-design-grey14;
		}

		&--leaf {
			border-bottom: 1px solid Colors.$col-design-grey14;
			z-index: 1;
		}

		&--group {
			z-index: 2;
			min-width: 0;
		}

		&--last-col {
			border-right: 0;

			&::after {
				display: none;
			}
		}

		&--fixed {
			position: sticky;
			background-color: Colors.$col-design-grey12;
			z-index: 5;
		}
	}

	&__header-cell {
		@include cell(header);
		position: relative;
		display: flex;
		flex-direction: row;
		align-items: stretch;
		justify-content: stretch;
		width: 100%;
		height: 100%;
		min-width: 0;
		box-sizing: border-box;
		padding: 0;

		&__content {
			flex: 1 1 auto;
			min-width: 0;
			height: 100%;
			display: flex;
			align-items: center;
			justify-content: center;
			box-sizing: border-box;
		}

		&__name-with-icon {
			flex: 1 1 auto;
			min-width: 0;
			height: 100%;
			display: flex;
			align-items: center;
			justify-content: center;
			text-align: center;
			word-break: break-word;
		}

		&__name {
			display: -webkit-box;
			-webkit-box-orient: vertical;
			overflow: hidden;
			overflow-wrap: anywhere;
		}

		&--leaf {
			.simple-table__header-cell__content {
				align-items: flex-end;
			}

			.simple-table__header-cell__name-with-icon {
				align-items: flex-end;
				padding-bottom: 6px;
			}
		}

		&--group {
			color: white;
			font-weight: bold;
		}
	}

	&__cell--fixed {
		background-color: Colors.$col-design-grey13;
		z-index: 30;

		border-right: 1px solid Colors.$col-design-grey14;

		&::after {
			content: '';
			position: absolute;
			top: 0;
			right: -1px;
			bottom: 0;
			width: 1px;
			background-color: Colors.$col-design-grey14;
			pointer-events: none;
		}
	}

	&__header-grid-cell--fixed,
	&__header-cell--fixed {
		background-color: Colors.$col-design-grey12;
		z-index: 50;
	}

	&__header-grid-cell--fixed {
		position: sticky;
	}
}

@keyframes simpleTableDrawerIn {
	from {
		transform: translateX(100%);
	}

	to {
		transform: translateX(0);
	}
}

.simple-table-shell {
	position: relative;
	display: flex;
	width: 100%;
	min-width: 0;
	align-items: stretch;

	&__table {
		flex: 1 1;
		min-width: 0;
	}

	&__rail {
		width: 32px;
		min-width: 32px;
		display: flex;
		flex-direction: column;
		align-self: stretch;
		background-color: Colors.$col-design-grey12;
		border-top: 1px solid Colors.$col-design-grey14;
		border-right: 1px solid Colors.$col-design-grey14;
		border-bottom: 1px solid Colors.$col-design-grey14;
		border-left: none;
		position: relative;
		z-index: 60;
		box-sizing: border-box;
	}

	&__rail-header {
		display: flex;
		justify-content: center;
		align-items: flex-start;
		padding-top: 6px;
		height: 32px;
		flex: 0 0 auto;
	}

	&__icon-button {
		width: Constants.$val-icon20;
		height: Constants.$val-icon20;
		cursor: pointer;
		font-size: Constants.$val-fontSizeXBig;
		line-height: 1;
		color: Colors.$col-design-grey15;
	}

	&__drawer {
		position: fixed;
		top: calc($var-company-header-height + $var-breadcrumbs-header-height + $var-tabs-navigation-height + 129px);
		right: Constants.$val-spacing-m;
		bottom: 0px;
		width: 320px;
		z-index: 9999;
		background-color: Colors.$col-design-grey12;
		border: 1px solid Colors.$col-design-grey14;
		box-sizing: border-box;

		display: flex;
		flex-direction: column;
		box-shadow: $var-shadow;
	}

	&__drawer-header {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: Constants.$val-spacing-s;
		padding: Constants.$val-spacing-s;
		border-bottom: 1px solid Colors.$col-design-grey14;
		background-color: Colors.$col-design-grey12;
	}

	&__drawer-title {
		font-size: Constants.$val-fontSizeBig;
		font-weight: bold;
		text-transform: uppercase;
		color: Colors.$col-design-grey900;
		letter-spacing: 0.2px;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	&__drawer-content {
		flex: 1 1 auto;
		min-height: 0;
		overflow-y: auto;
	}
}